import React, {Component} from 'react';
import ReactSVG from 'react-svg';

import SelectBubble from '../../components/onboarding/SelectBubble';
import AllergiesInput from './AllergiesInput';

import { MultComponentButton } from './OnboardingStyles';
import {answerBubbleStyle, answerBubbleStyleMobile} from '../../utils/styles';
import '../../components/onboarding/SelectBubble.css';

class Allergies extends Component {
    constructor(props){
        super(props);

        this.handleDone = this.handleDone.bind(this);
        this.handleNo = this.handleNo.bind(this);
        this.handleOnclick = this.handleOnclick.bind(this);
        this.renderAllergies = this.renderAllergies.bind(this);
        this.handleAllSelect = this.handleAllSelect.bind(this);

        this.allergies = [];
        this.allergyIndices = [];

        this.allergiesStr = '';
        this.itemsSelected = 0;

        this.state = {
            noSelected: false,
            nutsSelected:false,
            glutenSelected:false,
            acidsSelected:false,
            citrusSelected:false,
            parabensSelected: false,
            retinolSelected: false,
            alcoholSelected:false,
            fragranceSelected:false,
            otherMultipleSelected:false,
            otherInputText: '',
            showText: this.props.showText,
        };
    }

    componentDidMount(){
        var doneButton = document.querySelector(".allergiesConten");
        if (doneButton) doneButton.scrollIntoView();

         // 进度条
        try {
            if(this.props.fun_updateStage){
            var stage = this.props.stage;
            var stageSum = this.props.stageSum;
            if(stage && stageSum)
            this.props.fun_updateStage(parseInt(stage)-1,stageSum);
            }
        } catch (error) {
            console.error(error);
        }
    }

    componentDidUpdate () {
      var doneButton = document.querySelector(".allergiesConten");
      if (doneButton) doneButton.scrollIntoView();
    }


    handleDone() {
        if (this.itemsSelected > 0 || this.state.noSelected) {
            this.setState({ finished: true });
            this.allergiesStr = this.allergies.join(", ");
            let allergyIndicesStr = this.allergyIndices.join(", ");
            // Check if "Other" option is selected
            const index = this.allergyIndices.indexOf(10);
            if (index > -1 && this.state.otherInputText && this.state.otherInputText !== 'Other') {
                allergyIndicesStr = allergyIndicesStr.replace("10", "10:" + this.state.otherInputText);
            }
            localStorage.setItem("SQ_allergys",allergyIndicesStr);
            try {
                let step = this.props.step;
                localStorage.setItem("doneQuizStepId",step.id);
            } catch (error) {
                console.error(error);
            }

            try {
                if(this.props.fun_updateStage){
                  var stage = this.props.stage;
                  var stageSum = this.props.stageSum;
                  if(stage && stageSum)
                  this.props.fun_updateStage(stage,stageSum);
                }
              } catch (error) {
                console.error(error);
               
            }

            this.props.step.value = {value:allergyIndicesStr, label: this.allergiesStr};
            this.props.triggerNextStep({ value: {value:allergyIndicesStr, label: this.allergiesStr} });
           
        }else{
            alert("Please select an answer.");
        }
    }

    handleAllSelect(){
        this.itemsSelected = 8;
        this.allergies = [];
        this.allergyIndices = [];
        this.addItem({ index: 2, value: "Nuts" });
        this.addItem({ index: 3, value: "Gluten" });
        this.addItem({ index: 4, value: "Acids" });
        this.addItem({ index: 5, value: "Citrus" });
        this.addItem({ index: 6, value: "Parabens" });
        this.addItem({ index: 7, value: "Retinol" });
        this.addItem({ index: 8, value: "Alcohol" });
        this.addItem({ index: 9, value: "Fragrance" });

        this.setState({
            nutsSelected:true,
            glutenSelected:true,
            acidsSelected:true,
            citrusSelected:true,
            parabensSelected: true,
            retinolSelected: true,
            alcoholSelected:true,
            fragranceSelected:true,
            otherMultipleSelected:false
        });
    }


    handleNo() {
        if (this.itemsSelected < 1) {
            let selected = !this.state.noSelected;

            this.setState((prevState, props) => ({
                noSelected: !prevState.noSelected
            }));

            if (selected) {
                this.addItem({ index: 1, value: "I am not allergic to any of these ingredients" });
            } else {
                this.removeItem({ index: 1, value: "I am not allergic to any of these ingredients" });
            }

        } else {
            this.itemsSelected = 0;
            this.setState({
                nutsSelected:false,
                glutenSelected:false,
                acidsSelected:false,
                citrusSelected:false,
                parabensSelected: false,
                retinolSelected: false,
                alcoholSelected:false,
                fragranceSelected:false,
                otherMultipleSelected:false
            });
            this.allergies = [];
            this.allergyIndices = [];
        }
    }

    removeItem(answer) {
        let index = this.allergies.indexOf(answer.value);


        if (index > -1) {
            this.allergies.splice(index, 1);
        }
        index = this.allergyIndices.indexOf(answer.index);
        if (index > -1) {
            this.allergyIndices.splice(index, 1);
        }
    }

    addItem(answer) {
        let index = this.allergies.indexOf(answer.value);

        if (index === -1) {
            this.allergies.push(answer.value);
        }
        index = this.allergyIndices.indexOf(answer.index);
        if (index === -1) {
            this.allergyIndices.push(answer.index);
        }
    }

    getOtherInputValue(otherInput) {
        this.setState({
            otherInputText: otherInput.value
        });
    }

    handleOnclick(target) {
        if (this.state.noSelected) {
            this.itemsSelected = 0;
            this.allergies = [];
            this.allergyIndices = [];

            this.setState({
                noSelected: false
            });
            return;
        }

        if (target === "nutsSelected") {
            let selected = !this.state.nutsSelected;

            this.setState((prevState, props) => ({
                nutsSelected: !prevState.nutsSelected
            }));

            if (selected) {
                this.itemsSelected++;
                this.addItem({ index: 2, value: "Nuts" });
            } else {
                this.itemsSelected--;
                this.removeItem({ index: 2, value: "Nuts" });
            }
        }

        if (target === "glutenSelected") {
            let selected = !this.state.glutenSelected;

            this.setState((prevState, props) => ({
                glutenSelected: !prevState.glutenSelected
            }));

            if (selected) {
                this.itemsSelected++;
                this.addItem({ index: 3, value: "Gluten" });
            } else {
                this.itemsSelected--;
                this.removeItem({ index: 3, value: "Gluten" });
            }
        }

        if (target === "acidsSelected") {
            let selected = !this.state.acidsSelected;

            this.setState((prevState, props) => ({
                acidsSelected: !prevState.acidsSelected
            }));

            if (selected) {
                this.itemsSelected++;
                this.addItem({ index: 4, value: "Acids" });
            } else {
                this.itemsSelected--;
                this.removeItem({ index: 4, value: "Acids" });
            }
        }

        if (target === "citrusSelected") {
            let selected = !this.state.citrusSelected;

            this.setState((prevState, props) => ({
                citrusSelected: !prevState.citrusSelected
            }));

            if (selected) {
                this.itemsSelected++;
                this.addItem({ index: 5, value: "Citrus" });
            } else {
                this.itemsSelected--;
                this.removeItem({ index: 5, value: "Citrus" });
            }
        }

        if (target === "parabensSelected") {
            let selected = !this.state.parabensSelected;

            this.setState((prevState, props) => ({
                parabensSelected: !prevState.parabensSelected
            }));

            if (selected) {
                this.itemsSelected++;
                this.addItem({ index: 6, value: "Parabens" });
            } else {
                this.itemsSelected--;
                this.removeItem({ index: 6, value: "Parabens" });
            }
        }

        if (target === "retinolSelected") {
            let selected = !this.state.retinolSelected;

            this.setState((prevState, props) => ({
                retinolSelected: !prevState.retinolSelected
            }));

            if (selected) {
                this.itemsSelected++;
                this.addItem({ index: 7, value: "Retinol" });
            } else {
                this.itemsSelected--;
                this.removeItem({ index: 7, value: "Retinol" });
            }
        }

        if (target === "alcoholSelected") {
            let selected = !this.state.alcoholSelected;

            this.setState((prevState, props) => ({
                alcoholSelected: !prevState.alcoholSelected
            }));

            if (selected) {
                this.itemsSelected++;
                this.addItem({ index: 8, value: "Alcohol" });
            } else {
                this.itemsSelected--;
                this.removeItem({ index: 8, value: "Alcohol" });
            }

        }

        if (target === "fragranceSelected") {
            let selected = !this.state.fragranceSelected;

            this.setState((prevState, props) => ({
                fragranceSelected: !prevState.fragranceSelected
            }));

            if (selected) {
                this.itemsSelected++;
                this.addItem({ index: 9, value: "Fragrance" });
            } else {
                this.itemsSelected--;
                this.removeItem({ index: 9, value: "Fragrance" });
            }
        }

        if (target === "otherMultipleSelected") {
            let selected = !this.state.otherMultipleSelected;

            this.setState((prevState, props) => ({
                otherMultipleSelected: !prevState.otherMultipleSelected
            }));


            if (selected) {
                this.itemsSelected++;

            } else {
                this.itemsSelected--;
                this.removeItem({ index: 10, value: this.state.otherInputText });
                this.setState({ otherInputText: '' })
            }
        }
    }

    handleClassName(target) {
        let bubbleClassName = "multiselect-component__selectable"
        if (target !== "noSelected") {
            if (this.state.noSelected) bubbleClassName = bubbleClassName;
            else if(this.state[target]) bubbleClassName = bubbleClassName + " selected"; 
        } else {
            if (this.itemsSelected > 0) bubbleClassName = '';
            else if (this.state[target]){
                bubbleClassName = " selected";
            }else{
                bubbleClassName = ''
            }  
        }
        return bubbleClassName;
    }

    renderAllergies() {
        return (
            <div className="onb-item-container allergiesConten">
                <div className="onb-text-conten">{this.state.showText}</div>
                <div className="onb-se-allBut" style={{marginTop:'33px'}}>Select all that apply</div>
                <div className="container question-component__inner allergy-question">
                    <div className="multiselect-component multiselect-component_display-as-bubbles">
                        <SelectBubble
                            item="Fragrance"
                            className={this.handleClassName("fragranceSelected")}
                            selected={this.state.fragranceSelected}
                            handleOnClick={this.handleOnclick}
                            typeSelected="fragranceSelected"  
                            path='/images/onboarding/allergies/fragrance.svg'
                        />

                        <SelectBubble
                            item="Nuts"
                            selected={this.state.nutsSelected}
                            className={this.handleClassName("nutsSelected")}
                            handleOnClick={this.handleOnclick}
                            typeSelected="nutsSelected" 
                            path='/images/onboarding/allergies/nuts.svg'
                        />

                        <SelectBubble
                            item="Gluten"
                            selected={this.state.glutenSelected}
                            className={this.handleClassName("glutenSelected")}
                            handleOnClick={this.handleOnclick}
                            typeSelected="glutenSelected" 
                            path='/images/onboarding/allergies/gluten.svg'
                        />

                        <SelectBubble
                            item="Acids"
                            selected={this.state.acidsSelected}
                            className={this.handleClassName("acidsSelected")}
                            handleOnClick={this.handleOnclick}
                            typeSelected="acidsSelected"  
                            path='/images/onboarding/allergies/acid.svg'
                        />
                        <SelectBubble
                            item="Citrus"
                            selected={this.state.citrusSelected}
                            className={this.handleClassName("citrusSelected")}
                            handleOnClick={this.handleOnclick}
                            typeSelected="citrusSelected" 
                            path='/images/onboarding/allergies/citrus.svg'
                        />

                        <SelectBubble
                            item="Parabens"
                            selected={this.state.parabensSelected}
                            className={this.handleClassName("parabensSelected")}
                            handleOnClick={this.handleOnclick}
                            typeSelected="parabensSelected" 
                            path='/images/onboarding/allergies/parabens.svg' 
                        />

                        <SelectBubble
                            item="Retinol"
                            selected={this.state.retinolSelected}
                            className={this.handleClassName("retinolSelected")}
                            handleOnClick={this.handleOnclick}
                            typeSelected="retinolSelected" 
                            path='/images/onboarding/allergies/retinol.svg'
                        />

                        <SelectBubble
                            item="Alcohol"
                            selected={this.state.alcoholSelected}
                            className={this.handleClassName("alcoholSelected")}
                            handleOnClick={this.handleOnclick}
                            typeSelected="alcoholSelected" 
                            path='/images/onboarding/allergies/alcohol.svg'
                        />

                        <div className="bubble-wrapper other">
                            <div className={this.handleClassName("otherMultipleSelected")} 
                                onClick={() => this.handleOnclick("otherMultipleSelected")}>
                                <div className="checkbox">
                                    <div className="check fa fa-check"/>
                                </div>
                                <div className="multiselect-component__label">
                                    <div className="multiselect-component__image-wrapper">
                                        <div className="other-select-wrapper-text">Other</div>
                                    </div>

                                    <div className="multiselect-component__text">
                                        <div className="multiselect-component__title" >
                                        {!this.state.otherMultipleSelected ?
                                        "" :
                                        <AllergiesInput 
                                            addItem={this.addItem.bind(this)}
                                            removeItem={this.removeItem.bind(this)}
                                            otherMultipleSelected={this.state.otherMultipleSelected}
                                            sendOtherInputValue={this.getOtherInputValue.bind(this)}
                                        />
                                        }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div  className={this.handleClassName("noSelected") +" not-select-a-style" } onClick={this.handleNo}>
                            <span>I am not allergic to any</span>
                            <span>of these ingredients</span>
                        </div>

                    </div>
                </div>
                <button className="p-a-n-button submit-but" onClick={this.handleDone}>Continue</button>
            </div>





        )
    }

    render() {
        if (this.state.finished) {
            return(
                <div className="onb-item-container">
                    <div className="onb-text-conten">{this.state.showText}</div>
                </div>
            )
        } else {
            return (<div style={{margin: '1px auto'}}
                         className={this.state.finished ? 'rsc-ts sc-dnqmqq' : null}>{this.renderAllergies()}</div>)
        }
    }
}

export default Allergies;



// WEBPACK FOOTER //
// ./src/views/onboarding/Allergies.js